module.exports = __webpack_public_path__ + "img/mara.478af4a8.png";